<div class="tab-content user-management">
  <div>
    Add, invite, and manage users in your organization. Each user is assigned roles directly<span
      *ngIf="accountService.rbacFullEnabled"
    >
      or through groups</span
    >, which define what they can view or change in Arpio
  </div>
  <div class="flex justify-between margin-top">
    <div class="flex items-center">
      <h2>All Users</h2>
      <a
        *ngIf="canManageUsers$ | async"
        class="underline margin-left"
        (click)="openInviteUsersModal()"
        data-cy="invite-users-button"
        [class.loading]="openingInviteModal"
      >
        <i *ngIf="openingInviteModal" class="fa-solid fa-spinner fa-spin text-sm"></i>
        <i *ngIf="!openingInviteModal" class="fa-utility fa-semibold fa-plus text-sm"></i>
        Invite New Users
      </a>
    </div>
    <div class="flex items-center gap-4 user-management-filter-inputs-container half-margin-bottom">
      <!-- Role Filter Dropdown - Hidden when rbacEnabled is false -->
      <div class="filter-container" *ngIf="rbacEnabled">
        <div class="flex items-center gap-4">
          <div
            *ngIf="selectedRoleFilters.length > 0 || selectedGroupFilters.length > 0 || selectedIdpFilters.length > 0"
            class="filter-count"
          >
            ({{ selectedRoleFilters.length + selectedGroupFilters.length + selectedIdpFilters.length }}
            <span
              >filter<span
                *ngIf="selectedRoleFilters.length + selectedGroupFilters.length + selectedIdpFilters.length > 1"
                >s</span
              >
              applied.)</span
            >
            <button
              *ngIf="selectedRoleFilters.length > 0 || selectedGroupFilters.length > 0 || selectedIdpFilters.length > 0"
              class="clear-filters-btn"
              (click)="clearRoleFilters()"
            >
              Clear All
            </button>
          </div>
          <div class="filter-by-container" #filterDropdown>
            <button class="filter-by-button" (click)="toggleRoleFilterDropdown()">
              Filter by...
              <i class="fa-utility fa-semibold fa-angle-down"></i>
            </button>
            <div *ngIf="showRoleFilterDropdown" class="filter-by-dropdown">
              <!-- Identity Providers Section -->
              <div class="filter-section">
                <h3 class="filter-section-header" (click)="toggleFilterSection('identityProviders')">
                  <i
                    class="fa-utility fa-semibold"
                    [class.fa-angle-down]="filterSections.identityProviders"
                    [class.fa-angle-right]="!filterSections.identityProviders"
                  ></i>
                  Identity Providers
                </h3>
                <div class="filter-by-options" [class.collapsed]="!filterSections.identityProviders">
                  <div *ngFor="let idp of getAvailableIdentityProviders()" class="filter-option">
                    <input
                      type="checkbox"
                      class="arpio-checkbox"
                      [id]="'idp-filter-' + idp"
                      [checked]="selectedIdpFilters.includes(idp)"
                      (change)="onIdpFilterChange(idp, $any($event.target).checked)"
                    />
                    <label [for]="'idp-filter-' + idp">{{ idp }}</label>
                  </div>
                </div>
              </div>

              <!-- Roles Section -->
              <div class="filter-section">
                <h3 class="filter-section-header" (click)="toggleFilterSection('roles')">
                  <i
                    class="fa-utility fa-semibold"
                    [class.fa-angle-down]="filterSections.roles"
                    [class.fa-angle-right]="!filterSections.roles"
                  ></i>
                  Roles
                </h3>
                <div class="filter-by-options" [class.collapsed]="!filterSections.roles">
                  <div *ngFor="let role of getAvailableRoles()" class="filter-option">
                    <input
                      type="checkbox"
                      class="arpio-checkbox"
                      [id]="'role-filter-' + role"
                      [checked]="selectedRoleFilters.includes(role)"
                      (change)="onRoleFilterChange(role, $any($event.target).checked)"
                    />
                    <label [for]="'role-filter-' + role">{{ role }}</label>
                  </div>
                </div>
              </div>

              <!-- Groups Section -->
              <div class="filter-section">
                <h3 class="filter-section-header" (click)="toggleFilterSection('groups')">
                  <i
                    class="fa-utility fa-semibold"
                    [class.fa-angle-down]="filterSections.groups"
                    [class.fa-angle-right]="!filterSections.groups"
                  ></i>
                  Groups
                </h3>
                <div class="filter-by-options" [class.collapsed]="!filterSections.groups">
                  <div *ngFor="let group of getAvailableGroups()" class="filter-option">
                    <input
                      type="checkbox"
                      class="arpio-checkbox"
                      [id]="'group-filter-' + group"
                      [checked]="selectedGroupFilters.includes(group)"
                      (change)="onGroupFilterChange(group, $any($event.target).checked)"
                    />
                    <label [for]="'group-filter-' + group">{{ group }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-container">
        <input pInputText #filterInput type="text" (input)="filterGlobal($event)" placeholder="Search..." />
        <div
          *ngIf="!isFilterApplied && !loadingFilterInput"
          class="fa-utility-fill fa-semibold fa-filter fade-icon"
        ></div>
        <div
          *ngIf="isFilterApplied && !loadingFilterInput"
          (click)="clearInput()"
          class="fa-utility fa-semibold fa-xmark"
        ></div>
        <div *ngIf="loadingFilterInput" class="fa-solid fa-spinner fa-spin"></div>
      </div>
    </div>
  </div>
  <!-- Unauthorized State -->
  <div *ngIf="(canViewUsers$ | async) === false" class="unauthorized-container" data-cy="unauthorized-message">
    <div class="unauthorized-content">
      <h3>Access Restricted</h3>
      <p>{{ unauthorizedMessage$ | async }}</p>
    </div>
  </div>

  <!-- Authorized Content -->
  <div *ngIf="(canViewUsers$ | async) === true && users != null; else loadingBlock" class="table-container">
    <div class="table-section main-table" *ngIf="users.length > 0; else noUsersBlock">
      <p-table
        #dt1
        [value]="filteredUsers"
        [globalFilterFields]="globalFilterFields"
        dataKey="accountSubjectId"
        data-cy="user-table"
        [scrollable]="true"
        scrollHeight="60vh"
        [styleClass]="'p-datatable-sm arp-prime-datatable'"
        [rowHover]="true"
        [totalRecords]="users?.length"
        [paginator]="false"
        [rowTrackBy]="userTrackBy"
        selectionMode="single"
        [(selection)]="selectedTableItem"
        (onRowSelect)="onRowSelect($event.data)"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name" class="strong-text name-th">Name <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="email" class="strong-text email-th">Email <p-sortIcon field="email"></p-sortIcon></th>
            <th *ngIf="rbacEnabled" pSortableColumn="roles" class="strong-text roles-th">
              Roles <p-sortIcon field="roles"></p-sortIcon>
            </th>
            <th *ngIf="rbacEnabled" pSortableColumn="groups" class="strong-text groups-th">
              Groups <p-sortIcon field="groups"></p-sortIcon>
            </th>
            <th pSortableColumn="identityProviderName" class="strong-text idp-th">
              Identity Provider <p-sortIcon field="identityProviderName"></p-sortIcon>
            </th>
            <th pSortableColumn="lastActive" class="strong-text last-active-th">
              Last Active <p-sortIcon field="lastActive"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-user let-index="rowIndex">
          <tr
            [pSelectableRow]="user"
            [ngClass]="{
              'selected-row': showSidePanel && selectedUser && selectedUser.accountSubjectId === user.accountSubjectId,
              'default-role-row': isLoggedInUser(user),
              'refreshing-row': isUserRefreshing(user),
            }"
            data-cy="user-row"
          >
            <td class="name-column" style="position: relative">
              <div class="user-info">
                <div class="rbac-table-display-container">
                  <i class="fa-solid fa-spinner fa-spin half-margin-right" *ngIf="isUserRefreshing(user)"></i>
                  <span>{{ user.name + (isLoggedInUser(user) ? ' (You)' : '') }}</span>
                </div>
              </div>
            </td>
            <td class="email-column">
              <div class="rbac-table-display-container">
                <span>{{ user.email }}</span>
              </div>
            </td>
            <td *ngIf="rbacEnabled" class="roles-column">
              <div class="roles-list">
                <span *ngIf="user.roles.length === 0 && user.ssoRoles.length === 0">
                  <em>None</em>
                </span>
                <!-- Manual roles -->
                <a
                  *ngFor="let role of user.roles | slice: 0 : 2"
                  [routerLink]="['/' + accountService.accountId + '/settings/role-management']"
                  [queryParams]="{ selectRole: role.name }"
                  class="role-tag-link"
                >
                  <p-tag severity="info" class="role-tag clickable-tag" value="{{ role.name }}"> </p-tag>
                </a>
                <!-- SSO roles (with icon) -->
                <a
                  *ngFor="let role of user.ssoRoles | slice: 0 : Math.max(0, 2 - user.roles.length)"
                  [routerLink]="['/' + accountService.accountId + '/settings/role-management']"
                  [queryParams]="{ selectRole: role.name }"
                  class="role-tag-link sso-role"
                >
                  <p-tag severity="info" class="role-tag clickable-tag sso-tag">
                    <i class="fa-utility fa-semibold fa-id-card sso-icon"></i>
                    <span>{{ role.name }}</span>
                  </p-tag>
                </a>
                <span
                  *ngIf="user.roles.length + user.ssoRoles.length > 2"
                  class="more-count"
                  [pTooltip]="getAdditionalRolesTooltip(user)"
                  tooltipStyleClass="custom-scrollable-tooltip badge-tooltip"
                  tooltipPosition="top"
                  [autoHide]="false"
                  [hideDelay]="200"
                  [escape]="false"
                  tooltipEvent="hover"
                >
                  +{{ user.roles.length + user.ssoRoles.length - 2 }} more
                </span>
              </div>
            </td>
            <td *ngIf="rbacEnabled" class="groups-column">
              <div class="groups-list">
                <span *ngIf="user.groups.length === 0 && user.ssoGroups.length === 0">
                  <em>None</em>
                </span>
                <!-- Manual groups -->
                <a
                  *ngFor="let group of user.groups | slice: 0 : 2"
                  [routerLink]="['/' + accountService.accountId + '/settings/group-management']"
                  [queryParams]="{ selectGroup: group.name }"
                  class="group-tag-link"
                >
                  <p-tag severity="info" class="group-tag clickable-tag" value="{{ group.name }}"> </p-tag>
                </a>
                <!-- SSO groups (with icon) -->
                <a
                  *ngFor="let group of user.ssoGroups | slice: 0 : Math.max(0, 2 - user.groups.length)"
                  [routerLink]="['/' + accountService.accountId + '/settings/group-management']"
                  [queryParams]="{ selectGroup: group.name }"
                  class="group-tag-link sso-group"
                >
                  <p-tag severity="info" class="group-tag clickable-tag sso-tag">
                    <i class="fa-utility fa-semibold fa-id-card sso-icon"></i>
                    <span>{{ group.name }}</span>
                  </p-tag>
                </a>
                <span
                  *ngIf="user.groups.length + user.ssoGroups.length > 2"
                  class="more-count"
                  [pTooltip]="getAdditionalGroupsTooltip(user)"
                  tooltipStyleClass="custom-scrollable-tooltip badge-tooltip"
                  tooltipPosition="top"
                  [autoHide]="false"
                  [hideDelay]="200"
                  [escape]="false"
                  tooltipEvent="hover"
                >
                  +{{ user.groups.length + user.ssoGroups.length - 2 }} more
                </span>
              </div>
            </td>
            <td class="idp-column">
              {{ user.identityProviderName }}
            </td>
            <td class="last-active-column">
              <div class="rbac-table-display-container">
                <span
                  [pTooltip]="getLastActiveTooltip(user.lastActive)"
                  tooltipStyleClass="arp-tooltip"
                  tooltipPosition="top"
                  [autoHide]="false"
                  [hideDelay]="200"
                  tooltipEvent="hover"
                  >{{ getLastActiveDisplay(user.lastActive) }}</span
                >
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="rbacEnabled ? 6 : 4" class="empty-state-cell text-center">
              <div class="empty-state-content">
                <p class="empty-state-message">No results found</p>
                <p class="empty-state-submessage">Try adjusting your search or filter criteria.</p>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            <span
              >Displaying {{ dt1.filteredValue?.length ?? dt1.value?.length }} of {{ dt1.value?.length }} users</span
            >
          </div>
        </ng-template>
      </p-table>
    </div>

    <ng-template #noUsersBlock>
      <!-- Empty State -->
      <div class="empty-state-container">
        <div class="empty-state-content">
          <h3>No users have been created yet.</h3>
          <p>Users can be assigned to roles or groups within your arpio application.</p>
        </div>
      </div>
    </ng-template>

    <!-- Side Panel -->
    <div class="side-panel" [ngClass]="{ open: showSidePanel }" #sidePanel data-cy="user-sidebar">
      <div class="side-panel-header">
        <div class="flex items-center">
          <button class="close-btn" (click)="closeSidePanel()">
            <i class="fa-utility fa-semibold fa-angle-right"></i>
          </button>
          <h3>User Details</h3>
        </div>
        <div>
          <button
            *ngIf="rbacEnabled && selectedUser && (canManageUsers$ | async)"
            class="edit-button"
            (click)="openEditUserModal()"
          >
            <i class="fa-utility fa-semibold fa-pen-to-square"></i>
          </button>
        </div>
      </div>

      <div class="side-panel-content">
        <!-- Basic Information Section -->
        <div class="detail-section">
          <div class="detail-item">
            <label>Name:</label>
            <span *ngIf="showSidePanel && selectedUser">{{ selectedUser.name }}</span>
            <div *ngIf="!showSidePanel || !selectedUser" class="detail-skeleton"></div>
          </div>

          <div class="detail-item">
            <label>Email:</label>
            <span *ngIf="showSidePanel && selectedUser">{{ selectedUser.email }}</span>
            <div *ngIf="!showSidePanel || !selectedUser" class="detail-skeleton"></div>
          </div>
          <div *ngIf="!isNativeArpioUser(selectedUser)" class="detail-item">
            <label></label><em class="text-right">This user is associated with an external Identity Provider</em>
          </div>
        </div>

        <!-- Assigned Roles Section -->
        <div class="detail-section" *ngIf="rbacEnabled">
          <h4 *ngIf="showSidePanel && selectedUser">
            Assigned Roles ({{ getUserRoles().length + (selectedUser?.ssoRoles?.length || 0) }})
          </h4>

          <div class="detail-item display-block">
            <div
              *ngIf="
                showSidePanel &&
                selectedUser &&
                (getUserRoles().length > 0 || (selectedUser.ssoRoles && selectedUser.ssoRoles.length > 0))
              "
              class="roles-list"
            >
              <!-- Manual roles -->
              <a
                *ngFor="let role of getUserRoles()"
                [routerLink]="['/' + accountService.accountId + '/settings/role-management']"
                [queryParams]="{ selectRole: role.name }"
                class="role-tag-link"
              >
                <p-tag severity="info" class="role-tag clickable-tag">
                  {{ role.name }}
                </p-tag>
              </a>
              <!-- SSO roles -->
              <a
                *ngFor="let role of selectedUser.ssoRoles"
                [routerLink]="['/' + accountService.accountId + '/settings/role-management']"
                [queryParams]="{ selectRole: role.name }"
                class="role-tag-link sso-role"
              >
                <p-tag severity="info" class="role-tag clickable-tag sso-tag">
                  <i class="fa-utility fa-semibold fa-id-card sso-icon"></i>
                  <span>{{ role.name }}</span>
                </p-tag>
              </a>
            </div>
            <div
              *ngIf="
                showSidePanel &&
                selectedUser &&
                getUserRoles().length === 0 &&
                (!selectedUser.ssoRoles || selectedUser.ssoRoles.length === 0) &&
                isNativeArpioUser(selectedUser)
              "
              class="no-data-text"
            >
              No roles assigned
            </div>
            <div *ngIf="!showSidePanel || !selectedUser" class="detail-skeleton"></div>
          </div>
        </div>

        <!-- Assigned Groups Section -->
        <div class="detail-section" *ngIf="rbacEnabled">
          <h4 *ngIf="showSidePanel && selectedUser">
            Assigned Groups ({{ getUserGroups().length + (selectedUser?.ssoGroups?.length || 0) }})
          </h4>

          <div class="detail-item display-block">
            <div
              *ngIf="
                showSidePanel &&
                selectedUser &&
                (getUserGroups().length > 0 || (selectedUser.ssoGroups && selectedUser.ssoGroups.length > 0))
              "
              class="groups-list"
            >
              <!-- Manual groups -->
              <a
                *ngFor="let group of getUserGroups()"
                [routerLink]="['/' + accountService.accountId + '/settings/group-management']"
                [queryParams]="{ selectGroup: group.name }"
                class="group-tag clickable-tag"
              >
                {{ group.name }}
              </a>
              <!-- SSO groups -->
              <a
                *ngFor="let group of selectedUser.ssoGroups"
                [routerLink]="['/' + accountService.accountId + '/settings/group-management']"
                [queryParams]="{ selectGroup: group.name }"
                class="group-tag-link sso-group"
              >
                <p-tag severity="info" class="group-tag clickable-tag sso-tag">
                  <i class="fa-utility fa-semibold fa-id-card sso-icon"></i>
                  <span>{{ group.name }}</span>
                </p-tag>
              </a>
            </div>
            <div
              *ngIf="
                showSidePanel &&
                selectedUser &&
                getUserGroups().length === 0 &&
                (!selectedUser.ssoGroups || selectedUser.ssoGroups.length === 0) &&
                isNativeArpioUser(selectedUser)
              "
              class="no-data-text"
            >
              No groups assigned
            </div>
            <div *ngIf="!showSidePanel || !selectedUser" class="detail-skeleton"></div>
          </div>
        </div>

        <!-- Additional Information Section -->
        <div class="detail-section" *ngIf="selectedUser?.subject || !showSidePanel">
          <h4>Additional Information</h4>

          <div class="detail-item" *ngIf="selectedUser?.subject?.identityProviderId || !showSidePanel">
            <label>Identity Provider:</label>
            <span *ngIf="showSidePanel && selectedUser?.subject?.identityProviderId">{{
              getIdentityProviderName(selectedUser)
            }}</span>
            <div *ngIf="!showSidePanel || !selectedUser?.subject?.identityProviderId" class="detail-skeleton"></div>
          </div>

          <div class="detail-item">
            <label>Status:</label>
            <div class="flex-row items-center gap-2">
              <a
                *ngIf="canResendVerificationEmail()"
                class="resend-verification-button"
                (click)="resendVerificationEmail()"
              >
                <i class="fa-utility fa-semibold fa-envelope"></i>
                Resend Email
              </a>
              <p-tag
                *ngIf="showSidePanel && selectedUser"
                [value]="selectedUser.verified ? 'Verified' : 'Unverified'"
                [severity]="selectedUser.verified ? 'success' : 'warn'"
                [icon]="!selectedUser.verified ? 'fa-utility fa-semibold fa-circle-exclamation warning-icon' : null"
                [title]="!selectedUser.verified ? 'Email not verified' : null"
              ></p-tag>
            </div>
            <div *ngIf="!showSidePanel || !selectedUser" class="tag-skeleton"></div>
          </div>

          <div class="detail-item">
            <label>Last Login:</label>
            <span
              *ngIf="showSidePanel && selectedUser"
              [innerHTML]="getLastActiveSidePanelDisplay(selectedUser.lastActive)"
            ></span>
            <div *ngIf="!showSidePanel || !selectedUser" class="detail-skeleton"></div>
          </div>

          <div class="detail-item" *ngIf="selectedUser?.subject?.createdAt || !showSidePanel">
            <label>Created At:</label>
            <span *ngIf="showSidePanel && selectedUser?.subject?.createdAt">{{
              selectedUser.subject.createdAt | date: 'medium'
            }}</span>
            <div *ngIf="!showSidePanel || !selectedUser?.subject?.createdAt" class="detail-skeleton"></div>
          </div>
        </div>
        <!-- Action Buttons Section -->
        <div
          class="detail-section action-buttons"
          *ngIf="showSidePanel && selectedUser && (canResendInviteEmail() || canDeleteUser())"
          data-cy="actions-section"
        >
          <h4>Actions</h4>
          <div class="flex-row items-center gap-2 margin-top">
            <!-- Resend Invite Button-->
            <div *ngIf="canResendInviteEmail()" class="margin-auto text-center margin-top">
              <a class="resend-invite-button text-center" (click)="resendInviteEmail()" data-cy="resend-invite-button">
                <i class="fa-utility fa-semibold fa-envelope"></i>
                Resend Invite Email
              </a>
            </div>
            <!-- Delete Button -->
            <div class="margin-auto text-center margin-top">
              <a
                *ngIf="canDeleteUser()"
                class="delete-user-button text-center"
                (click)="deleteUser()"
                data-cy="delete-user-button"
              >
                Delete User...
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loadingBlock> <i class="fa-solid fa-spinner fa-spin"></i> Loading users... </ng-template>

  <app-invite-users-modal #inviteUsersModal (usersInvited)="onUsersInvited()"></app-invite-users-modal>
  <app-edit-user-modal #editUserModal (userUpdated)="onUserUpdated($event)"></app-edit-user-modal>

  <!-- Delete User Confirmation Modal -->
  <modal-dialog #deleteUserDialog [dialogTemplate]="confirmDeleteUserDialog"></modal-dialog>
  <ng-template #confirmDeleteUserDialog>
    <confirm-action-dialog
      name="&quot;{{ userToDelete?.name }}&quot; ({{ userToDelete?.email }})"
      action="Delete"
      [error]="deleteUserDialog.error"
      [busy]="deletingUser"
      (onCancel)="cancelDeleteUser()"
      (onAction)="confirmDeleteUser()"
    >
      <div class="error margin-top">
        Deleting this user will permanently remove them from the account and revoke all their access. This action cannot
        be undone.
      </div>
    </confirm-action-dialog>
  </ng-template>
</div>
